import { refreshAnimations } from './animations.js';

const challengeSwiperEl = document.querySelector('.challenge-cards-swiper');
if (!challengeSwiperEl) {
  // Not on the homepage
} else {
  const desktopQuery = window.matchMedia('(min-width: 40rem)');
  let swiperInstance = null;

  const createSwiper = () => {
    if (swiperInstance) return;
    swiperInstance = new Swiper(challengeSwiperEl, {
      slidesPerView: 1.25,
      centeredSlides: true,
      spaceBetween: 0,
      grabCursor: true,
      navigation: {
        nextEl: '.challenge-carousel-next',
        prevEl: '.challenge-carousel-prev',
      },
    });
    refreshAnimations();
  };

  const destroySwiper = () => {
    if (!swiperInstance) return;
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  };

  const syncSwiper = () => {
    if (desktopQuery.matches) {
      destroySwiper();
    } else {
      createSwiper();
    }
    refreshAnimations();
  };

  syncSwiper();
  desktopQuery.addEventListener('change', syncSwiper);
}
